import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Menu from '@mui/material/Menu';
import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { PropTypes } from 'prop-types';
import { useMutation } from '@apollo/client';

import { CAN_ADD_TIMEBLOCK } from '../../constants/permissions';
import { useAuth } from '../../context/AuthContext';
import { ALLOCATION_PERCENT } from '../../apis/user';
import useWorkspace from '../../context/WorkspaceContext';

const CustomRadio = (props) => (
  <Radio
    disableRipple
    checkedIcon={<CheckCircleIcon sx={{ color: '#2E72F6', padding: '0' }} />}
    icon={<RadioButtonUncheckedIcon sx={{ display: 'none' }} />}
    {...props}
  />
);

const propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]),
  userId: PropTypes.number,
  userProjectSkillDetails: PropTypes.func,
};

const defaultProps = {
  data: [],
  userId: null,
  userProjectSkillDetails: () => {},
};

const AllocationDropDownRenderer = React.forwardRef(
  ({ data, userId, userProjectSkillDetails }, ref) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const value = data.allocationPercent;
    const [updateAllocationPercent] = useMutation(ALLOCATION_PERCENT);
    const { userPermissions } = useWorkspace();
    const { authUser } = useAuth();
    const currentUser = authUser.id;
    const permissions = [];
    if (userPermissions !== undefined) {
      if (userPermissions.permissions !== undefined) {
        userPermissions.permissions.map((x) => permissions.push(x));
      }
    }

    const open = Boolean(anchorEl);
    const canChangeAllocation =
      permissions.includes(CAN_ADD_TIMEBLOCK) || parseInt(currentUser, 10) === parseInt(userId, 10);
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const handleChange = async (event) => {
      const variables = {
        input: {
          userId,
          projectId: data.projectId,
          allocation_percent: parseInt(event.target.value, 10),
        },
      };
      await updateAllocationPercent({ variables });
      await userProjectSkillDetails();
      setAnchorEl(null);
    };

    return (
      <div className="flexbox">
        <div style={{ width: '40px' }}>{`${value}%`}</div>
        {canChangeAllocation && (
          <div>
            <KeyboardArrowDownIcon
              sx={{
                color: '#344054',
                borderRadius: '50%',
                cursor: 'pointer',
                width: '20px',
                height: '20px',
              }}
              onClick={handleClick}
            />
          </div>
        )}
        <Menu
          className="status-list-dropdown"
          id="basic-menu"
          ref={ref}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          PaperProps={{
            style: {
              padding: '7px',
              border: '1px solid #D0D5DD',
              boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.12)',
              borderRadius: '2px !important',
              width: '132px',
            },
          }}
        >
          <FormControl sx={{ width: '100%' }}>
            <span
              style={{
                fontSize: '9px',
                margin: '10px',
                lineHeight: '130%',
                fontWeight: 400,
                color: '#475467',
              }}
            >
              Capacity
            </span>
            <RadioGroup
              sx={{ width: '100%' }}
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={value}
              onChange={handleChange}
            >
              <FormControlLabel
                value="100"
                control={<CustomRadio />}
                label="100%"
                labelPlacement="start"
              />
              <FormControlLabel
                value="50"
                control={<CustomRadio />}
                label="50%"
                labelPlacement="start"
              />
            </RadioGroup>
          </FormControl>
        </Menu>
      </div>
    );
  },
);

AllocationDropDownRenderer.propTypes = propTypes;
AllocationDropDownRenderer.defaultProps = defaultProps;
export default AllocationDropDownRenderer;
